<style>
	.goods-company-summary-base{
		float: left;
		width: 100%;
		background-color: #fff;
		font-size: .9em;
		padding:.7em 0;
		margin-top: 5px;
	}
	.goods-company-summary-left,.goods-company-summary-right{
		box-sizing: border-box;
		float: left;
		position: relative;
		height: 100%;
	}
	.goods-company-summary-right {
		float: right;
	}
	.clear-float{
		clear:both;
	}
	.goods-company-summary-left{
		/* width: 100%; */
		padding-left: 1em;
	}
	.goods-company-summary-left>div{
		position: relative;
		height:30px;
		line-height: 30px;
	}
	.goods-company-summary-edit{
		position: absolute;
		right: 7px;
		top: 7px;
		height: 24px;
		line-height: 24px;
		padding-right: 18px;
		font-size: 14px;
		color: #fff;
		background:url(../assets/sift.png) no-repeat right center;
		background-size: auto 14px;
	}
	.goods-company-summary-excel{
		position: absolute;
		right: 50px;
		top: 9px;
		width: 25px;
		height: 25px;
		background:url(../assets/excel.png) no-repeat;
		background-size: contain;
	}
	.lightblack-font{
		color: #353535
	}
	.goods-company-ico,.goods-company-name{
		float: left;
	}
	.goods-company-ico{
		width: 30px;
		height: 30px;
		background:url(../assets/house-ico.png) no-repeat;
		background-size: contain;
	}
	.goods-company-name{
		position: relative;
		font-size: 1.3em;
		margin-left:5px;
	}
	.goods-company-status{
		float:right;
		margin-left:20px;
		background-color: #25a0a3;
		padding: 0 10px;
		color: #fff;
		height: 25px;
		line-height: 25px;
		margin-top: 2px;
		border-radius:2px;
	}
	.goods-company-summary-wrapper{
		box-sizing: border-box;
		width: 100%;
		margin-top: 5px;
		background-color: #fff;
		padding: .7em 1em 6px;
	}
	.goods-company-summary-wrapper .goods-company-detail-content {
		font-size: .9em;
		color: #656565;
	}
	.goods-company-detail-show{
		margin-left: 10%;
	}
	.goods-company-detail-show-ul{
		float: left;
		width: 100%;
	}
	.goods-company-detail-show-ul li{
		float: left;
		width: 50%;
		font-size: .9em;
		color: #656565;
	}
	.goods-company-detail {
		color: #000000;
		line-height: 22px;
	}
	.goods-company-detail-name{
		display: inline-block;
		font-size: 1em;
		font-weight: 500;
	}
	.goods-money-summary .goods-company-detail-money {
		float: right;
		font-size: .9em;
		font-weight: 300;
	}
	.goods-company-house {
		width: 90%;
	}
	.title-font {
		font-size: .9em;
		font-weight: 700;
		color: #656565;
	}

	.goods-money-summary .goods-company-detail-content{
		height: auto;
	}
	.goods-company-detail-list:last-child{
		border-bottom: none;
		margin-bottom: 0;
	}
	.goods-company-detail-show{
		margin-top: 5px;
		overflow: hidden;
	}
	.gd {
		/* float: right; */
		/* display: inline-block; */
		height: 25px!important;
		padding-top: 5px;
		margin-right: 5px;
	}
	.gd > span {
		display: inline-block;
		vertical-align: top;
	}
	.imp_btn {
		position: absolute;
		right: 55px;
		top: 7px;
	}
	.switch {
		position: relative;
		display: inline-block;
		width: 40px;
		height: 24px;
}

	.switch input {display:none;}

	.slider {
		position: absolute;
		cursor: pointer;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: #ccc;
		-webkit-transition: .4s;
		transition: .4s;
	}
	.slider:before {
		position: absolute;
		content: "";
		height: 18px;
		width: 18px;
		left: 4px;
		bottom: 3px;
		background-color: white;
		-webkit-transition: .4s;
		transition: .4s;
	}

	input:checked + .slider {
		background-color: #25a0a3;
	}

	input:focus + .slider {
		box-shadow: 0 0 1px #2196F3;
	}

	input:checked + .slider:before {
		-webkit-transform: translateX(26px);
		-ms-transform: translateX(26px);
		transform: translateX(14px);
	}

	/* Rounded sliders */
	.slider.round {
		border-radius: 34px;
	}

	.slider.round:before {
		border-radius: 50%;
	}
	.goods-total-1 {
		margin-left: 70px;
	}
	.wind-bottom-btn-bar{
		position: fixed;
		right: 0;
		bottom: 0;
		left: 0;
		background-color: #fff;
		height: 42px;
		display: flex;
		justify-content: flex-end;
	}
	.wind-button{
		align-items: center;
		display: flex;
		flex-direction: row;
		justify-content: center;
		border: 0 none;
		font-size: 14px;
		height: 42px;
		line-height: 42px;
		position: relative;
		box-sizing: border-box;
		overflow: hidden;
		white-space: nowrap;
		padding: 0 28px;
	}
</style>
<template>
<div class="edi-allorderbill goods-money-summary">
	<navbar title="金额汇总-餐企"></navbar>
	<span class="goods-company-summary-edit" @click="summaryFilter">筛选</span>
	<div class="common-scroll" id="common-scroll"  @scroll="refresh" style="bottom: 42px">
		<div class="container" v-if="!midware" v-show="!loading">
			<!-- 餐企、订货日期、编辑栏 v-if="!midware"-->
			<div class="goods-company-summary-base">
				<div class="goods-company-summary-left">
					<div>
						<span>
							<i class="goods-company-ico"></i><strong class="goods-company-name">{{store.goodsTotalInfo.restaurant_name}}</strong>
						</span>
					</div>
					<div class="lightblack-font">
						<span v-if="goodsTotalInfo.sort_method === '0'">订货日期：</span>
						<span v-if="goodsTotalInfo.sort_method === '1'">到货日期：</span>
						{{store.goodsTotalInfo.start_date}} 至 {{store.goodsTotalInfo.end_date}}
					</div>
				</div>
			</div>
			<div class="clear-float"></div>
			<!-- 明细条目栏 -->
			<div class="goods-company-summary-wrapper" v-if="goodsTotalInfo.select_detail==0">
				<div v-for="billCount in billCounts" class="goods-company-detail-content goods-company-detail-list">
					<div class="goods-company-detail">
						<strong class="goods-company-detail-name">{{billCount.organName ? billCount.organName : billCount.goods_name}}</strong>
						<div v-if="billCount.sub_total > 0">
							<span>订：</span>
							<span>含税金额：¥ {{billCount.sub_total}}</span>
						</div>
						<div v-if="billCount.sub_total_send > 0">
							<span>发：</span>
							<span>含税金额：¥ {{billCount.sub_total_send}}</span>
						</div>
						<div v-if="billCount.sub_total_recipient > 0">
							<span>收：</span>
							<span>含税金额：¥ {{billCount.sub_total_recipient}}</span>
						</div>
						<div v-if="billCount.return_sub_total > 0">
							<span>退：</span><span>含税金额：¥ {{billCount.return_sub_total}}</span>
						</div>
					</div>
					<div class="clear-float"></div>
				</div>
			</div>
		</div>
		<refresh v-show="!show" :cls="cls" :font="font"></refresh>
		<mid-ware v-show="midware" :icon="icon" :midFont="midFont"></mid-ware>
	</div>
	<tips-auto v-show="tipsauto" :tipsFont = "tipsFont"></tips-auto>
	<loading v-show="loading"></loading>
	<get-total v-show="total" ref="cTotal" :filter="filterData" totalHref="/cldEdi/business/getShopMoneySumReportTotal" name="餐企"></get-total>
	<summary-filter ref="summaryShow" v-on:searchPost="getSearchCondition"></summary-filter>
</div>
</template>
<script>
import BillCountFilter from '../components/BillCountFilter'
import GetTotal from '../components/GetMoneyTotal'
import Loading from '../components/loading'
import Tips from '../components/Tips'
import TipsAuto from '../components/TipsAuto'
import MidWare from '../components/MidWare'
import Refresh from '../components/refresh'
import NavBar from '../components/NavBar'
import MoneySummaryFilter from '../components/MoneySummaryFilter'
import { GlobalStore } from '../store/globalStore'
import FxShare from '../components/Fx-share'
import SideFloat from '../components/SideFloat'
export default {
	data () {
		return {
			midware: false,
			icon: '',
			midFont: '',
			total: false,
			loading: false,
			tips: false,
			tipsauto: false,
			msg: [],
			btnNum: 1,
			tipsFont: '',
			queryData: this.$route.query,
			allInfo: null,
			billCounts: [],
			show: true,
			cls: '',
			font: '',
			bill_state: '14,21',
			sort_method: '0',
			restaurant_id: '',
			organIds: '',
			start_date: '',
			end_date: '',
			length: 10,
			start: 0,
			filterData: {},
			sec: 1500,
			prevLength: 0,
			restaurant_name: '',
			store: GlobalStore,
			goodsTotalInfo: {},
			gord: true,
			groupByHouse: false
			// copyPopShow: false
		}
	},
	components: {
		'bill-filter': BillCountFilter,
		'get-total': GetTotal,
		'loading': Loading,
		'tips': Tips,
		'tips-auto': TipsAuto,
		'mid-ware': MidWare,
		'refresh': Refresh,
		'navbar': NavBar,
		'summary-filter': MoneySummaryFilter,
		FxShare,
		SideFloat
	},
	created () {
		// this.storeHandle()
		// this.getGoodsList()
	},
	mounted () {
		this.summaryFilter()
	},
	watch: {
		// gord (bool) {
		// 	this.getGoodsList(bool)
		// },
		// groupByHouse () {
		// 	this.getGoodsList()
		// }
	},
	methods: {
		storeHandle () {
			this.goodsTotalInfo = this.store.goodsTotalInfo
			if (this.goodsTotalInfo.start_date === undefined) {
				var d = new Date()
				var year = d.getFullYear()
				var month = d.getMonth()
				var m = new Date(year, month + 1, 0)
				var day = m.getDate()
				month < 9 ? (month = '0' + (month + 1)) : month = d.getMonth() + 1
				this.goodsTotalInfo.start_date = d.getFullYear() + '-' + month + '-' + '01'
				this.goodsTotalInfo.end_date = d.getFullYear() + '-' + month + '-' + day
			}
			if (this.goodsTotalInfo.restaurant_name === undefined) {
				this.goodsTotalInfo.restaurant_name = '请选择餐企'
			}
			if (this.goodsTotalInfo.restaurant_id === undefined) {
				this.goodsTotalInfo.restaurant_id = ''
			}
			if (this.goodsTotalInfo.sort_method === undefined) {
				this.goodsTotalInfo.sort_method = '0'
			}
			if (this.goodsTotalInfo.bill_state === undefined) {
				this.goodsTotalInfo.bill_state = '14,21'
			}
			if (this.goodsTotalInfo.select_detail === undefined) {
				this.goodsTotalInfo.select_detail = ''
			}
			if (this.goodsTotalInfo.organIds === undefined) {
				this.goodsTotalInfo.organIds = []
			}
		},
		dateCut (val) {
			var arr = val.split(' ')
			return arr[0]
		},
		summaryFilter () {
			this.storeHandle()
			var obj = {
				restaurant_name: this.goodsTotalInfo.restaurant_name,
				restaurant_id: this.goodsTotalInfo.restaurant_id,
				organ_name: this.goodsTotalInfo.organ_name,
				organIds: this.goodsTotalInfo.organIds,
				bill_state: this.goodsTotalInfo.bill_state,
				sort_method: this.goodsTotalInfo.sort_method,
				start_date: this.goodsTotalInfo.start_date,
				end_date: this.goodsTotalInfo.end_date,
				select_detail: this.goodsTotalInfo.select_detail
			}
			this.$refs.summaryShow.open(obj)
		},
		autoTips (msg) {
			var self = this
			self.tipsauto = true
			self.tipsFont = msg
			setTimeout(() => {
				self.tipsauto = false
			}, self.sec)
		},
		getSearchCondition (msg) {
			// 获得查询条件开始查询
			// window.console.log(msg)
			var goodsTotalInfo = this.store.goodsTotalInfo
			goodsTotalInfo.bill_state = msg.bill_state
			goodsTotalInfo.sort_method = msg.sort_method
			goodsTotalInfo.select_detail = msg.select_detail //
			goodsTotalInfo.restaurant_id = msg.restaurant_id
			goodsTotalInfo.restaurant_name = msg.restaurant_name
			goodsTotalInfo.organIds = msg.organIds
			goodsTotalInfo.organ_name = msg.organ_name
			goodsTotalInfo.start_date = msg.start_date
			goodsTotalInfo.end_date = msg.end_date
			// goodsTotalInfo.group_by_organ = msg.group_by_organ //
			this.start = 0
			// window.console.log(goodsTotalInfo)
			this.getGoodsList()
		},
		getGoodsList (groupByOrgan) {
			this.storeHandle()
			this.loading = true
			this.midware = false
			var goodsTotalInfo = this.store.goodsTotalInfo
			var searchCondition = {
				shopMoneyFlag: '1',
				bill_state: goodsTotalInfo.bill_state,
				date_type: goodsTotalInfo.sort_method,
				restaurant_id: goodsTotalInfo.restaurant_id,
				fromOrganId: goodsTotalInfo.organIds.join(','),
				start_date: goodsTotalInfo.start_date,
				end_date: goodsTotalInfo.end_date,
				select_detail: goodsTotalInfo.select_detail,
				group_by_organ: this.gord ? '1' : '0',
				group_by_house: this.groupByHouse ? '1' : '0',
				length: this.length,
				start: this.start
			}
			if (groupByOrgan !== undefined) {
				searchCondition.group_by_organ = groupByOrgan ? '1' : '0'
			}
			this.$http.post('/cldEdi/business/getShopMoneySumReportDetail', searchCondition).then((response) => {
				var allInfo = response.body.data
				this.loading = false
				if (!allInfo) {
					this.autoTips('合计查询失败')
					return
				}

				this.restaurant_name = allInfo.restaurant_name
				this.restaurant_id = allInfo.restaurant_id
				this.organIds = goodsTotalInfo.organIds
				this.start_date = allInfo.startDate
				this.end_date = allInfo.endDate
				this.bill_state = allInfo.bill_state
				if (allInfo.sort_method !== null && allInfo.sort_method !== undefined) {
					this.sort_method = allInfo.sort_method
				}
				this.filterData = {
					shopMoneyFlag: '1',
					bill_state: this.bill_state,
					date_type: goodsTotalInfo.sort_method,
					restaurant_id: this.restaurant_id,
					start_date: this.start_date,
					end_date: this.end_date,
					fromOrganId: this.organIds.join(',')
				}
				// 注释有问题吗？？
				if (allInfo.restaurant_name !== undefined) {
					this.goodsTotalInfo.restaurant_id = this.restaurant_id
					this.goodsTotalInfo.restaurant_name = this.restaurant_name
				}

				this.billCounts = response.body.data.details
				// window.console.log(this.billCounts)
				if (this.billCounts === undefined) {
					this.total = false
					this.midware = true
					this.icon = 'middle-empty'
					this.midFont = '没有数据'
					return false
				}
				this.prevLength = this.billCounts.length
				this.total = true
			}, (response) => {
				this.loading = false
				this.midware = true
				this.icon = 'middle-net'
				this.midFont = '服务中断，稍后请重试！'
			})
		},
		refresh () {
			var goodsTotalInfo = this.store.goodsTotalInfo
			var el = document.getElementById('common-scroll')
			var marginBot = el.scrollHeight - (el.scrollTop + document.body.scrollTop) - el.clientHeight
			if (marginBot <= 10) {
				this.show = false
				if (this.prevLength < 10 || this.billCounts.length < (this.start + 1) * 10) {
					this.cls = 'remind'
					this.font = '已经没有数据'
					var self = this
					setTimeout(() => {
						self.show = true
					}, 1500)
					return false
				}
				this.cls = 'update'
				this.font = '加载中...'
				this.start ++
				var start = this.start * 10
				var searchCondition = {
					shopMoneyFlag: '1',
					bill_state: goodsTotalInfo.bill_state,
					date_type: goodsTotalInfo.sort_method,
					restaurant_id: goodsTotalInfo.restaurant_id,
					fromOrganId: goodsTotalInfo.organIds.join(','),
					start_date: goodsTotalInfo.start_date,
					end_date: goodsTotalInfo.end_date,
					length: this.length,
					start: start
				}
				this.$http.post('/cldEdi/business/getShopMoneySumReportDetail', searchCondition).then((response) => {
					this.show = true
					var data = response.body.data.details
					if (data) {
						this.prevLength = data.length
						this.billCounts = this.billCounts.concat(data)
					}
				}, (response) => {
					this.loading = false
					this.midware = true
					this.icon = 'middle-net'
					this.midFont = '服务中断，稍后请重试！'
				})
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// GoodsMoneySummary.vue?7d9bf84c